import { FormControl, FormHelperText, makeStyles, MenuItem, Select } from "@material-ui/core";
import React from "react";
import Color from "../../styles/Color";
// import Select from 'react-select'
const styles = makeStyles(theme => ({
    papperSelectPrimary: {
        backgroundColor: Color.primary,
        color: "#fff",
        marginTop: 2,
        animation: "animated_content_popper ease-in-out .15s forwards",
    },
    papperSelect: {
        marginTop: 2,
        animation: "animated_content_popper ease-in-out .15s forwards",
    },

    formControlPrimary: {
        position: "relative",
        backgroundColor: Color.primary,
        borderRadius: 5,
        "& .MuiOutlinedInput-inputMarginDense": {
            paddingTop: 15,
            paddingBottom: 15,
        },
        "& .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: Color.primary,
        },
        "& .MuiSelect-icon": {
            color: "inherit",
            top: "calc(50% - 10px)",
        },
        "& .MuiInputBase-root .MuiSelect-root": {
            position: "relative",
        },
        "& .MuiInputBase-root.placeholder .MuiSelect-root::before": {
            content: "attr(textplaceholder)",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            textAlign: "start",
            color: "#8cd5ea",
        },
        "& .MuiInputBase-root": {
            color: "#fff",
            overflow: "hidden",
        },
        "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: "red",
            borderWidth: 1,
        },
        "& .MuiFormHelperText-root": {
            position: "absolute",
            left: 0,
            bottom: -23,
            width: "100%",
            marginLeft: 0,
            marginRigth: 0,
            "&.Mui-error": {
                color: "red",
            },
        },
    },
    formControl: {
        position: "relative",
        backgroundColor: "#fff",
        borderRadius: 5,
        "& .MuiOutlinedInput-inputMarginDense": {
            paddingTop: 15,
            paddingBottom: 15,
        },
        "& .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0000",
            borderWidth: 1,
        },
        "& .MuiSelect-icon": {
            color: "inherit",
            top: "calc(50% - 10px)",
        },
        "& .MuiInputBase-root .MuiSelect-root": {
            position: "relative",
        },
        "& .MuiInputBase-root.placeholder .MuiSelect-root::before": {
            content: "attr(textplaceholder)",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            textAlign: "start",
            color: "#dbdbdb",
        },
        "& .MuiInputBase-root": {
            color: "inherit",
            overflow: "hidden",
        },
        "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: "red",
            borderWidth: 1,
        },
        "& .MuiFormHelperText-root": {
            position: "absolute",
            left: 0,
            bottom: -23,
            width: "100%",
            marginLeft: 0,
            marginRigth: 0,
            "&.Mui-error": {
                color: "red",
            },
        },
    },
}));

export default function SelectDropOtions({
    onChange = () => {},
    value = "",
    helperText = "",
    error = false,
    options = [],
    renderOption = (option, index) => <MenuItem value=""></MenuItem>,
    placeholder = "",
    useTheme = false,
    containerClass = "",
    papperClass = {},
    disabled = false
}) {
    // coding......
    const classes = styles();
    const handleChange = event => {
        onChange(event.target.value);
    };
    return (
        <FormControl
            variant={"outlined"}
            size="small"
            fullWidth
            className={`${useTheme ? classes.formControlPrimary : classes.formControl} ${containerClass}`}>
            <Select
                MenuProps={{
                    classes: { paper: `${useTheme ? classes.papperSelectPrimary : classes.papperSelect} ${papperClass}` },
                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                    getContentAnchorEl: null,
                }}
                value={value}
                onChange={handleChange}
                className={`${(!value || value === "") && (placeholder || placeholder === "") ? "placeholder" : ""}`}
                error={error}
                SelectDisplayProps={{ textplaceholder: placeholder }} disabled={disabled}>
                {placeholder ? (
                    <MenuItem value={""} className="text-muted">
                        {placeholder}
                    </MenuItem>
                ) : null}
                {options.map((row, idx) => renderOption(row, idx))}
            </Select>

            {error ? <FormHelperText {...(error ? { error: true } : {})}>{helperText}</FormHelperText> : null}
        </FormControl>
    );
}
